// Runtime white-labeling + feature flags for a customer instance. Loaded once
// at boot (before React renders) from /api/instance-config, which the backend
// derives from this customer's env. Everything downstream reads BRAND/FEATURES.
export const BRAND = { name: "Helpdesk", logo_url: "/logo.jpg", tagline: "Support Platform", primary_color: null, theme: "cyber" };
// Which light/dark base each brand theme looks best on (used only to pick a
// sensible default the first time; the in-app light/dark toggle still works).
const THEME_BASE = { cyber: "dark", clean: "light", bold: "light", terminal: "dark" };
// Feature flags = what the customer's PLAN + configuration unlocks. All paid
// add-ons default OFF so nothing is auto-included; the server sends the real
// values from /api/instance-config (derived from the license plan).
export const FEATURES = {
  m365_sso: false,        // O365 SSO — only when the customer configured Azure
  server_rmm: false,      // Server RMM add-on
  client_database: false, // Client & Website Registry add-on
  dev_queue: false,
  infrastructure: false,
  mdm: false,
  ftr_ai: false,
  security: false,
};

export async function loadBrand() {
  const base = process.env.REACT_APP_API_URL || "";
  try {
    const r = await fetch(base + "/api/instance-config");
    if (r.ok) {
      const d = await r.json();
      if (d.brand) {
        if (d.brand.name) BRAND.name = d.brand.name;
        if (d.brand.logo_url) BRAND.logo_url = d.brand.logo_url;
        if (typeof d.brand.tagline === "string") BRAND.tagline = d.brand.tagline;
        BRAND.primary_color = d.brand.primary_color || null;
        if (["cyber", "clean", "bold", "terminal"].includes(d.brand.theme)) BRAND.theme = d.brand.theme;
      }
      if (d.features) Object.assign(FEATURES, d.features);
    }
  } catch { /* keep neutral defaults */ }
  try { document.title = BRAND.name; } catch {}
  if (BRAND.primary_color) { try { document.documentElement.style.setProperty("--brand-primary", BRAND.primary_color); } catch {} }
  // Apply the chosen brand theme (re-accents the whole app) and, on first load
  // only, default the light/dark base to what suits that theme. ThemeContext
  // reads "midtc-theme" from localStorage, so seeding it here wins the race.
  try {
    // A user's personal choice (localStorage, kept by ThemeContext) wins; the
    // instance default only seeds first-time visitors. Never forced afterward.
    const savedBrand = localStorage.getItem("midtc-brand");
    const brandToApply = ["cyber", "clean", "bold", "terminal"].includes(savedBrand) ? savedBrand : BRAND.theme;
    document.documentElement.setAttribute("data-brand-theme", brandToApply);

    const savedMode = localStorage.getItem("midtc-theme");
    const modeToApply = ["dark", "light"].includes(savedMode) ? savedMode : (THEME_BASE[BRAND.theme] || "dark");
    document.documentElement.setAttribute("data-theme", modeToApply);
    if (!savedMode) localStorage.setItem("midtc-theme", modeToApply);
  } catch { /* no-op */ }
}
